<template>
  <div class="site-page nav-content-inset">
    <div class="site-page__inner">
      <h1 class="site-page__title">常见问题</h1>
      <div class="site-page__card site-page__faq">
        <el-collapse v-model="activeNames">
          <el-collapse-item v-for="(faq, index) in faqs" :key="index" :name="index">
            <template #title>
              <div class="faq-title">{{ faq.question }}</div>
            </template>
            <div class="faq-answer">{{ faq.answer }}</div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FAQView',
  data() {
    return {
      activeNames: [0],
      faqs: [
        {
          question: '礼券与推荐怎么玩？',
          answer:
            '在「我的」进入「我的礼券」创建双享礼券并分享注册/绑定链接；新用户注册时填券号或打开链接即可绑定。臻享合伙人须实名后申请，审核通过可设臻享礼券并享客户终身分润。详见帮助中心或 /referral/coupons。'
        },
        {
          question: '分润什么时候到账？',
          answer:
            '客户购买测评/课程等内容后，分润先显示为「预估」（消费申诉期内），申诉期结束后再进入「待到账」，T+N 天后入账余额。可在「推荐收益」查看明细，并导出对账单。'
        },
        {
          question: '如何申诉退款？',
          answer:
            '在「交易记录」中，申诉期内的消费扣款可点击「申诉退款」，填写理由并上传凭证。管理员审核通过后全额退回余额；拒绝或要求补充材料会通过站内信通知。'
        },
        {
          question: '如何提现？',
          answer:
            '在「我的 → 创作与提现 → 提现申请」填写银行卡信息提交；管理员审核通过后，财务批量导出打款。打款结果可在申请记录中查看。'
        },
        {
          question: 'CoolPeople 是什么？',
          answer:
            'CoolPeople 是一个连接有趣的人、分享经验与认知的平台，支持编辑推荐、心智测试、课程与社交发现等功能。'
        },
        {
          question: '如何注册账号？',
          answer: '点击顶栏「登录」，可使用账号密码或微信等方式注册/登录（以站点实际开放方式为准）。'
        },
        {
          question: '基础功能是否免费？',
          answer: '部分编辑推荐与测评可免费使用；付费测评或课程需在平台内购买后查看完整报告或内容。'
        },
        {
          question: '如何联系客服或反馈问题？',
          answer: '可通过「联系我们」页面留言，或使用「意见反馈」提交建议与问题。'
        },
        {
          question: '推荐使用什么浏览器？',
          answer: '建议使用 Chrome、Firefox、Safari、Edge 等现代浏览器的最新版本，移动端与桌面端均可访问。'
        }
      ]
    }
  }
}
</script>
